import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// Page Layout
const PageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  width: 100vw;
  background-color: #f4f6f9;
`;

// Success Message Container
const SuccessContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
  text-align: center;
`;

// Title and Message Styling
const Title = styled.h1`
  font-size: 2.5rem;
  color: #003366;
  margin-bottom: 1.5rem;
  font-family: 'Roboto', sans-serif;
`;

const Message = styled.p`
  font-size: 1.2rem;
  color: #555555;
  margin-bottom: 20px;
  font-family: 'Roboto', sans-serif;
`;

const InfoMessage = styled.p`
  font-size: 1rem;
  color: #888888;
  margin-bottom: 30px;
  font-family: 'Roboto', sans-serif;
  text-align: center;
`;

// Button Styling
const Button = styled.button`
  padding: 15px 30px;
  font-size: 1.2rem;
  background-color: #1e90ff;
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;

  &:hover {
    background-color: #4682b4;
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
`;

const SuccessPage = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate('/'); // Navigate to the homepage or login page
  };

  return (
    <PageContainer>
      <SuccessContainer>
        <Title>Cadastro Realizado com Sucesso!</Title>
        <Message>
          Parabéns! Seu cadastro foi realizado com sucesso. Agora, nossa equipe da Realoca Fácil irá analisar o seu perfil.
        </Message>
        <InfoMessage>
          Enviaremos um email assim que o seu cadastro for aprovado e informaremos os próximos passos para você começar a utilizar a plataforma.
        </InfoMessage>
        <Button onClick={handleGoHome}>Voltar para a Página Inicial</Button>
      </SuccessContainer>
    </PageContainer>
  );
};

export default SuccessPage;
